import API_BASE, { withApiCredentials } from "../../api";

function buildHeaders(authToken) {
  return authToken ? { Authorization: `Bearer ${authToken}` } : {};
}

async function parseNotificationResponse(response, requiredKeys) {
  if (!response.ok) {
    throw new Error(`Notification request failed with status ${response.status}`);
  }

  const payload = await response.json();
  if (!payload || typeof payload !== "object") {
    throw new Error("Notification response was invalid");
  }

  for (const key of requiredKeys) {
    if (!(key in payload)) {
      throw new Error(`Notification response omitted ${key}`);
    }
  }

  if (
    "unreadCount" in payload &&
    (!Number.isInteger(payload.unreadCount) || payload.unreadCount < 0)
  ) {
    throw new Error("Notification response included an invalid unread count");
  }

  return payload;
}
export async function fetchNotifications({ authToken, signal } = {}) {
  const response = await fetch(
    `${API_BASE}/notifications`,
    withApiCredentials({ headers: buildHeaders(authToken), signal })
  );
  const payload = await parseNotificationResponse(response, [
    "notifications",
    "unreadCount",
  ]);

  if (!Array.isArray(payload.notifications)) {
    throw new Error("Notification response included an invalid list");
  }

  return payload;
}

export async function fetchUnreadCount({ authToken, signal } = {}) {
  const response = await fetch(
    `${API_BASE}/notifications/unread-count`,
    withApiCredentials({ headers: buildHeaders(authToken), signal })
  );
  return parseNotificationResponse(response, ["unreadCount"]);
}

export async function markNotificationRead(
  notificationId,
  { authToken, signal } = {}
) {
  const response = await fetch(
    `${API_BASE}/notifications/${encodeURIComponent(notificationId)}/read`,
    withApiCredentials({
      method: "PATCH",
      headers: buildHeaders(authToken),
      signal,
    })
  );
  const payload = await parseNotificationResponse(response, [
    "ok",
    "notificationId",
    "unreadCount",
  ]);
  if (payload.ok !== true || payload.notificationId !== notificationId) {
    throw new Error("Notification mutation response was invalid");
  }
  return payload;
}

export async function markAllNotificationsRead({ authToken, signal } = {}) {
  const response = await fetch(
    `${API_BASE}/notifications/mark-all-read`,
    withApiCredentials({
      method: "POST",
      headers: buildHeaders(authToken),
      signal,
    })
  );
  const payload = await parseNotificationResponse(response, ["ok", "unreadCount"]);
  if (payload.ok !== true) {
    throw new Error("Notification mutation response was invalid");
  }
  return payload;
}
